<!-- <div *ngIf="dataSource.data.length > 0; else noOffers"> -->

<div class="page-container">
  <div class="offers-page">
    <mat-toolbar class="cdc-header">
      <span>{{ 'Offers' | translate }}</span>

      <div class="d-flex flex-row align-items-center gap-2">
        <div class="cdc-form-field m-0 actif">
          <input matInput (keyup)="applyFilter($event)" class="editInput" placeholder="{{ 'Search' | translate }}">
        </div>
        <button mat-stroked-button (click)="addNewOffer()" class="cdc-button">{{ 'New Offer' | translate }}</button>
      </div>
    </mat-toolbar>

    <div class="div-table">
      <div class="mat-elevation-z8 col-11 col-md-11 col-lg-11 m-3">
        <table mat-table [dataSource]="dataSource" matSort>

          <!-- ID Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
            <td mat-cell *matCellDef="let offer"> {{ offer.id }} </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Name' | translate }} </th>
            <td mat-cell *matCellDef="let offer"> {{ offer.name }} </td>
          </ng-container>

          <!-- Code Column -->
          <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Code' | translate }} </th>
            <td mat-cell *matCellDef="let offer"> {{ offer.code }} </td>
          </ng-container>

          <!-- Pages Column -->
          <ng-container matColumnDef="pages">
            <th mat-header-cell *matHeaderCellDef> {{ 'Pages' | translate }} </th>
            <td mat-cell *matCellDef="let offer" class="offers-cell">
              <ng-container *ngIf="offer && offer.pages !== null">
                <div #pageName *ngFor="let page of offer.pages" class="label label-primary offer-item" tooltipTruncate [matTooltip]="page.title!">
                  {{ page.title }}
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- IsRequired Column -->
          <ng-container matColumnDef="isRequired">
            <th mat-header-cell *matHeaderCellDef> {{ 'Required' | translate }} </th>
            <td mat-cell *matCellDef="let offer">
              <mat-icon *ngIf="offer.isRequired" class="cdc-icon-true">check</mat-icon>
              <mat-icon *ngIf="!offer.isRequired" class="cdc-icon-false">close</mat-icon>
            </td>
          </ng-container>

          <!-- Hidden Column -->
          <ng-container matColumnDef="hidden">
            <th mat-header-cell *matHeaderCellDef> {{ 'Single route' | translate }} </th>
            <td mat-cell *matCellDef="let offer">
              <mat-icon *ngIf="offer.hidden" class="cdc-icon-true">check</mat-icon>
              <mat-icon *ngIf="!offer.hidden" class="cdc-icon-false">close</mat-icon>
            </td>
          </ng-container>

          <!-- Expiration delay Column -->
          <ng-container matColumnDef="expirationDelay">
            <th mat-header-cell *matHeaderCellDef> {{ 'Expiration delay' | translate }} ({{ "hours" | translate }})</th>
            <td mat-cell *matCellDef="let offer"> {{ offer.expirationDelay }} {{ (offer.expirationDelay != undefined && offer.expirationDelay != null) ? (offer.expirationDelay > 1) ? ("hours" | translate) : ("hour" | translate) : '' }} </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let offer">
              <div matTooltip="{{ (offer.pages !== null && offer.pages.length > 0 ? 'Cannot Delete': 'Delete') | translate }}">
                <button mat-icon-button (click)="deleteOffer($event, offer)" [disabled]="offer.pages !== null && offer.pages.length > 0">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let offer; columns: displayedColumns" (click)="navigateToOffer(offer)" class="table-row"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="99">{{ 'No items to display' | translate }}</td>
          </tr>
        </table>
        <mat-paginator [length]="totalItems" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" [showFirstLastButtons]="true"></mat-paginator>
      </div>
    </div>
  </div>
</div>
